import { refreshQRCode } from '@webapps/business';
import { Loader, useMutation } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const EmargementContent = ({ classroomId, isLoading, lastQRCode }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [token, setToken] = useState("");

  const { mutateAsync: mutateRefreshQRCode, isLoading: isLoadingRefreshQRCode, data: dataRefreshQRCode } = useMutation(refreshQRCode, {
    onSuccess: ({ data }) => {
      console.log("mutateRefreshQRCode ", data);

      setToken(data?.token);
    },
  });


  useEffect(() => {
    const interval = setInterval(() => {
      if (!isLoadingRefreshQRCode && lastQRCode.id) {
        mutateRefreshQRCode({ classroomId }).then(({ data }) => {
          console.log("data token", data);

          setToken(data?.token);
          // refetchAllQRCode();
        });
      }
    }, 15000); // 15 secondes 
    return () => clearInterval(interval);
  }, [lastQRCode]);

  useEffect(() => {
    const refreshQRCode = async () => {
      const { data } = await mutateRefreshQRCode({ classroomId });
      setToken(data?.token);
    }

    lastQRCode.id && refreshQRCode();
  }, [lastQRCode]);

  console.log("lastQRCode", lastQRCode);

  const shouldDisplayLoader =
    isLoading.isLoadingGenerateQRCode ||
    isLoading.isLoadingLastQRCode ||
    isLoadingRefreshQRCode;


  return (
    <div className={classes.container}>
      {lastQRCode.id ? (
        shouldDisplayLoader ? (
          <Loader />
        ) : (
          <QRCodeSVG
            value={`http://localhost:8080/schools/module/classrooms/qr-code/scan?token=${token}`}
            size={150}
          />
        )
      ) : (
        <div>Aucun QR Code généré</div>
      )}

      {/* <div className={classes.listContainer}>
        <h3 className={classes.listTitle}>Historique des générations</h3>
        {
          allQRCode.map((time, index) => (
            <div key={index} className={classes.timeItem}>
              <span className={classes.time}>
                {time?.generatedAt}
              </span>
              <span className={classes.counter}>
                {time.signedCount}/{time.totalStudents}
              </span>
            </div>
          ))
        }
      </div> */}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(2),
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    gap: spacing(2),
  },
  listTitle: {
    margin: 0,
    marginBottom: spacing(1),
    color: '#152652',
    fontSize: '16px',
    fontWeight: 500,
  },
  timeItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: spacing(1, 0),
    borderBottom: '1px solid #E5E5E5',
    width: '100%',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  time: {
    color: '#5A6DA1',
    fontWeight: 500,
  },
  counter: {
    backgroundColor: '#F3F7FF',
    padding: spacing(0.5, 1),
    borderRadius: '4px',
    color: '#152652',
    fontSize: '14px',
    fontWeight: 500,
  },
});

export default EmargementContent;